
<template>
  <!--添加房间-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'addRoom',
  data () {
    function validateArea (rule, value, callback) {
      if (value < 1) {
        callback(new Error('建筑面积不能小于等于0'));
      } else {
        callback();
      }
    }
    let decoratorOptions = {
      community_id: {
        rules: [{ required: true, message: '请选择所属小区' }]
      },
      building_id: {
        rules: [{ required: true, message: '请选择所属楼栋' }]
      },
      unit_id: {
        rules: [{ required: true, message: '请选择所属单元' }]
      },
      room_no: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入房间号' },
          { min: 4, max: 4, message: '房间号为4位数' }
        ]
      },
      building_area: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入建筑面积'},
          { validator: validateArea }
        ]
      }
    };
    return {
      cascadeParam: {
        communityId: '',
        buildingId: ''
      },
      formKey: {
        community_id: '',
        building_id: '',
        unit_id: '',
        room_no: '',
        building_area: '',
        type: ''
      },
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          handle: e => {
            this.communityChange(1, e, 'formList');
            this.$children[0].resetSubValue(['building_id', 'unit_id'], e);
          },
          placeholder: '请选择小区',
          props: ['community_id', decoratorOptions.community_id]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          handle: e => {
            this.buildingChange(2, e, 'formList');
            this.$children[0].resetSubValue('unit_id', e);
          },
          placeholder: '请选择楼栋',
          props: ['building_id', decoratorOptions.building_id]
        },
        {
          label: '所属单元',
          inputType: 'select',
          options: [],
          placeholder: '请选择单元',
          props: ['unit_id', decoratorOptions.unit_id]
        },
        {
          label: '房间号',
          inputType: 'input',
          options: [],
          placeholder: '请输入房间号',
          type: 'number',
          props: ['room_no', decoratorOptions.room_no]
        },
        {
          label: '建筑面积',
          inputType: 'input',
          options: [],
          placeholder: '请输入建筑面积',
          type: 'number',
          props: ['building_area', decoratorOptions.building_area]
        },
        {
          label: '住宅类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择住宅类型',
          props: ['type', {
            rules: [{required: true, message: '请选择住宅类型'}]
          }]
        }
      ],
      addParam: {
        url: '/room/add',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/room/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/room/',
        resHandle: this.detailResHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.communitySelect(0, 'formList', 1);

      this.typeSelect({
        query: 'room_type_desc',
        handle: (data) => {
          this.formList[5].options = data;
        }
      });
    },
    detailResHandle (res) {
      this.limitEdit(res, ['community_id', 'building_id', 'unit_id']);
      res.community_id && this.communityChange(1, res.community_id, 'formList');
      res.building_id && this.buildingChange(2, res.building_id, 'formList');
      return {};
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/room/addRoom.vue